import * as React from 'react';

interface IusePreviousOptions {
  jsonParse: boolean;
}

// @note There are two usePrevious hooks - one here and one in App.tsx.
// This version uses JSON parse. The other in App.tsx not.
// We need to merge this into one. Let's discuss.
const usePrevious = (value: any, options?: IusePreviousOptions): any => {
  const ref: any = React.useRef();
  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  if (options?.jsonParse === false) {
    return ref.current;
  }

  return ref.current ? JSON.parse(ref.current) : [];
};

export default usePrevious;

// export const usePrevious = <T>(value: T): T | undefined => {
//   const ref = React.useRef<T>();
//   React.useEffect(() => {
//     ref.current = value;
//   });
//   return ref.current;
// };
